export enum AgendaUserRole {
    read,
    update
}
